import { useFetch } from "../../../hooks/api";
import { useAppSelector } from "../../../redux/hooks";
import useDSPSellerInfo from "./useDSPSellerInfo";

export const useDSPAdCreatives = () => {
  const { marketPlace } = useAppSelector((state) => state.marketPlace);
  const { dspAdvertiser } = useDSPSellerInfo();

  const { data, isLoading } = useFetch(
    ["dspAdCreatives", dspAdvertiser?.id],
    "/dsp/dsp_ad_creatives/",
    {
      marketplace: marketPlace,
      dsp_seller_info_id: dspAdvertiser?.id,
    },
    {
      select: (res) => {
        return res.data?.adCreatives ?? [];
      },
      default: [],
      staleTime: 60 * 5 * 1000,
    },
  );

  return { data, isLoading };
};
